import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import { formatPopularity } from "@/utils/movie";
import SectionHeading from "@/components/feature/SectionHeading";

interface HotRankListProps {
  movies: Movie[];
}

export default function HotRankList({ movies }: HotRankListProps) {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          title="热门播放榜"
          subtitle="按站点播放热度实时排序，看看大家都在追什么"
          moreLink="/category/hot"
        />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-2">
          {movies.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/detail/${movie.id}`}
              className="group flex items-center gap-4 py-3 border-b border-background-200 cursor-pointer"
              title={`${movie.title} - 激情丛林在线观看`}
            >
              <span
                className={`w-8 shrink-0 text-center font-heading text-xl font-extrabold ${
                  index < 3 ? "text-accent-500" : "text-foreground-300"
                }`}
              >
                {index + 1}
              </span>
              <span className="w-14 h-20 shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={movie.cover}
                  alt={`${movie.title}封面`}
                  title={`${movie.title} ${movie.type}`}
                  className="w-full h-full object-cover object-top"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm font-bold text-foreground-950 truncate group-hover:text-primary-700 transition-colors">
                  {movie.title}
                </span>
                <span className="block mt-1 text-xs text-foreground-500">
                  {movie.year} · {movie.type} · {movie.genres.join(" / ")}
                </span>
                <span className="mt-1.5 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500" aria-hidden="true"></i>
                    {movie.rating.toFixed(1)}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-accent-500" aria-hidden="true"></i>
                    {formatPopularity(movie.popularity)}
                  </span>
                </span>
              </span>
              <span className="shrink-0 w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className="ri-play-fill text-lg" aria-hidden="true"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}